<div class="matcher_container" *ngIf="currentItem">
  <div class="matcher_header">Convert Document References</div>
  <div class="matcher_info-box">
    <fa-icon [icon]="['fas', 'info-circle']" (click)="onMatcherInfoClick()"></fa-icon>
    <div>
      The reference below could not be found in your library. Please select a match to continue:
    </div>
  </div>
  <div class="matcher_title">
    <span>Reference {{currentItemIndex + 1}} of {{itemsToMatch.length}}</span>
    <span class="badge" (click)="itemsDisplayService.showItemPanel(currentItem)">View Details</span>
  </div>
  <div class="matcher_item-container">
    <div class="matcher_item-row">
      <div>Title</div>
      <div>{{currentItem.article?.title | truncate: 75}}</div>
    </div>
    <div class="matcher_item-row">
      <div>Author</div>
      <div>
        <span
          *ngFor="let author of currentItem.article?.authors?.slice(0,4)"
          class="list-item_author" >
          {{ author }}
        </span>
      </div>
    </div>
    <div class="matcher_item-row">
      <div>Year</div>
      <div>{{currentItem.article?.year}}</div>
    </div>
  </div>

  <scs-search 
    [matcherMode]="true">
  </scs-search>

  <scs-items
    id="scroll-wrapper-items"
    class="scroll-wrapper scroll-wrapper--xxxs scrollbar"
    [matcherMode]="true"
    (onMatched)="onItemMatched($event)">
  </scs-items>

  <button 
    class="matcher_button button-primary button-primary--sm button-primary--grey"
    (click)="onMatchNotFound()">
    Match not Found
  </button>
</div>
